export default __webpack_public_path__ + "static/media/better-mfa.362038d5.png";